var _path, _path2, _path3, _linearGradient, _path4, _linearGradient2, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetherlands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21468B",
    d: "M2,11.475c14.667-5.11,29.333,5.11,44,0c0,8.517,0,17.034,0,25.551c-14.667,5.11-29.333-5.11-44,0 C2,28.509,2,19.992,2,11.475z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2,11.475c14.667-5.11,29.333,5.11,44,0c0,5.678,0,11.356,0,17.034c-14.667,5.11-29.333-5.11-44,0 C2,22.831,2,17.153,2,11.475z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#AE1C28",
    d: "M2,11.475c14.667-5.11,29.333,5.11,44,0c0,2.839,0,5.678,0,8.517c-14.667,5.11-29.333-5.11-44,0 C2,17.153,2,14.314,2,11.475z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "TkAD2EaOXh~QHAAuV1WZ4a",
    x1: 2,
    x2: 46,
    y1: 25.75,
    y2: 25.75,
    gradientTransform: "matrix(1 0 0 -1 0 50)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#000819",
    stopOpacity: 0.309
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213,
    stopColor: "#000b24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#000b24",
    stopOpacity: 0.003
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#000b24",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    stopColor: "#000614",
    stopOpacity: 0.193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#000205",
    stopOpacity: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#000614",
    stopOpacity: 0.134
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#000b24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#000b24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#00081b",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#000104",
    stopOpacity: 0.638
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#TkAD2EaOXh~QHAAuV1WZ4a)",
    d: "M2,11.475c14.667-5.11,29.333,5.11,44,0 c0,8.517,0,17.034,0,25.551c-14.667,5.11-29.333-5.11-44,0C2,28.509,2,19.992,2,11.475z",
    opacity: 0.9
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "TkAD2EaOXh~QHAAuV1WZ4b",
    x1: 2,
    x2: 46,
    y1: 25.75,
    y2: 25.75,
    gradientTransform: "matrix(1 0 0 -1 0 50)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#fff",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#TkAD2EaOXh~QHAAuV1WZ4b)",
    d: "M2,11.475c14.667-5.11,29.333,5.11,44,0 c0,8.517,0,17.034,0,25.551c-14.667,5.11-29.333-5.11-44,0C2,28.509,2,19.992,2,11.475z",
    opacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetherlands);
export default __webpack_public_path__ + "static/media/netherlands.6efb1f731e00f9311d9ffe4bfbb935d0.svg";
export { ForwardRef as ReactComponent };